var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { Pane, Row, Col, AccordionSet, Accordion, PaneFooter, ErrorModal, Checkbox, TextArea, } from "@folio/stripes/components";
import { useQuery } from "react-query";
import { useIntl, FormattedMessage } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecekTextField, RecekSelect } from "../inputs";
import { HelpTooltip } from "../inputs/HelpTooltip";
import { fetchRegions } from "../../api/regionService";
import { LibraryDtoTypeEnum, } from "../../types/Api";
import { LibraryDtoLibrarySystemEnum } from "../../types/Library";
import { RecekPaneSet } from "../RecekPaneSet";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { createLibrarySchema } from "../../utils/validationUtils";
import { FormFooterStart } from "../FormFooterStart";
import { FormFooterEnd } from "../FormFooterEnd";
import { InfoBox } from "../InfoBox";
import { handleError, applyFieldErrors, formatModalErrors, } from "../../utils/errorHandler";
import { hasHttpResponse } from "../../utils/apiUtils";
import styles from "./LibraryForm.module.css";
import { useScrollToError } from "../../hooks/useScrollToError";
var LibraryForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _r = useState({
        general: true,
        legalDeposits: true,
        communication: true,
        dataCollection: true,
    }), accordionStatus = _r[0], setAccordionStatus = _r[1];
    var _s = useState(true), expandAll = _s[0], setExpandAll = _s[1];
    var _t = useState(false), errorModalOpen = _t[0], setErrorModalOpen = _t[1];
    var _u = useState([]), errorMessages = _u[0], setErrorMessages = _u[1];
    var _v = useForm({
        // strict is off in tsconfig, so zod infers every schema key as optional and the resolver type cannot match the form type
        resolver: zodResolver(createLibrarySchema(formatMessage)),
        defaultValues: {
            name: (_b = initialValues.name) !== null && _b !== void 0 ? _b : "",
            type: (_c = initialValues.type) !== null && _c !== void 0 ? _c : LibraryDtoTypeEnum.NATIONAL,
            regionId: (_d = initialValues.regionId) !== null && _d !== void 0 ? _d : null,
            nonPeriodicalsCountAllRegions: (_e = initialValues.nonPeriodicalsCountAllRegions) !== null && _e !== void 0 ? _e : 0,
            nonPeriodicalsCountOwnRegion: (_f = initialValues.nonPeriodicalsCountOwnRegion) !== null && _f !== void 0 ? _f : 0,
            periodicalsCount: (_g = initialValues.periodicalsCount) !== null && _g !== void 0 ? _g : 0,
            oaiUrlMonography: (_h = initialValues.oaiUrlMonography) !== null && _h !== void 0 ? _h : "",
            canRequestCopies: (_j = initialValues.canRequestCopies) !== null && _j !== void 0 ? _j : false,
            includeReferentInSignature: (_k = initialValues.includeReferentInSignature) !== null && _k !== void 0 ? _k : false,
            correspondenceContact: (_l = initialValues.correspondenceContact) !== null && _l !== void 0 ? _l : "",
            librarySystem: (_m = initialValues.librarySystem) !== null && _m !== void 0 ? _m : LibraryDtoLibrarySystemEnum.UNDEFINED,
            remindersEnabled: (_o = initialValues.remindersEnabled) !== null && _o !== void 0 ? _o : true,
            defaultReminderOffsetDays: (_p = initialValues.defaultReminderOffsetDays) !== null && _p !== void 0 ? _p : 0,
            defaultMinGapDays: (_q = initialValues.defaultMinGapDays) !== null && _q !== void 0 ? _q : 7,
        },
        mode: "onSubmit",
        shouldFocusError: false,
    }), handleSubmit = _v.handleSubmit, control = _v.control, reset = _v.reset, watch = _v.watch, setValue = _v.setValue, setError = _v.setError, errors = _v.formState.errors;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        reset({
            name: (_a = initialValues.name) !== null && _a !== void 0 ? _a : "",
            type: (_b = initialValues.type) !== null && _b !== void 0 ? _b : LibraryDtoTypeEnum.NATIONAL,
            regionId: (_c = initialValues.regionId) !== null && _c !== void 0 ? _c : null,
            nonPeriodicalsCountAllRegions: (_d = initialValues.nonPeriodicalsCountAllRegions) !== null && _d !== void 0 ? _d : 0,
            nonPeriodicalsCountOwnRegion: (_e = initialValues.nonPeriodicalsCountOwnRegion) !== null && _e !== void 0 ? _e : 0,
            periodicalsCount: (_f = initialValues.periodicalsCount) !== null && _f !== void 0 ? _f : 0,
            oaiUrlMonography: (_g = initialValues.oaiUrlMonography) !== null && _g !== void 0 ? _g : "",
            canRequestCopies: (_h = initialValues.canRequestCopies) !== null && _h !== void 0 ? _h : false,
            includeReferentInSignature: (_j = initialValues.includeReferentInSignature) !== null && _j !== void 0 ? _j : false,
            correspondenceContact: (_k = initialValues.correspondenceContact) !== null && _k !== void 0 ? _k : "",
            librarySystem: (_l = initialValues.librarySystem) !== null && _l !== void 0 ? _l : LibraryDtoLibrarySystemEnum.UNDEFINED,
            remindersEnabled: (_m = initialValues.remindersEnabled) !== null && _m !== void 0 ? _m : true,
            defaultReminderOffsetDays: (_o = initialValues.defaultReminderOffsetDays) !== null && _o !== void 0 ? _o : 0,
            defaultMinGapDays: (_p = initialValues.defaultMinGapDays) !== null && _p !== void 0 ? _p : 7,
        });
    }, [initialValues, reset]);
    var regionId = watch("regionId");
    useEffect(function () {
        if (!regionId) {
            setValue("nonPeriodicalsCountOwnRegion", 0);
        }
    }, [regionId, setValue]);
    useScrollToError(errors);
    var _w = useQuery(["regions"], function () { return fetchRegions(ky); }), regionsData = _w.data, isRegionsLoading = _w.isLoading;
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            legalDeposits: !expandAll,
            communication: !expandAll,
            dataCollection: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var showSaveError = function (error) {
        var errorMessageId = initialValues.id
            ? "ui-br-legaldeposits.libraries.edit.error.save"
            : "ui-br-legaldeposits.libraries.create.error.save";
        setErrorMessages([formatMessage({ id: errorMessageId })]);
        setErrorModalOpen(true);
        console.error("Error saving library:", error);
    };
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var libraryData, error_1, errorsResponse, _a, fieldErrors, modalErrors, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 9]);
                    libraryData = __assign(__assign({}, initialValues), { name: data.name, type: data.type, regionId: (_c = data.regionId) !== null && _c !== void 0 ? _c : undefined, nonPeriodicalsCountAllRegions: data.nonPeriodicalsCountAllRegions, nonPeriodicalsCountOwnRegion: data.nonPeriodicalsCountOwnRegion, periodicalsCount: data.periodicalsCount, oaiUrlMonography: data.oaiUrlMonography || undefined, canRequestCopies: data.canRequestCopies, includeReferentInSignature: data.includeReferentInSignature, correspondenceContact: data.correspondenceContact, librarySystem: data.librarySystem, remindersEnabled: data.remindersEnabled, defaultReminderOffsetDays: data.defaultReminderOffsetDays, defaultMinGapDays: data.defaultMinGapDays });
                    return [4 /*yield*/, onSubmit(libraryData)];
                case 1:
                    _d.sent();
                    return [3 /*break*/, 9];
                case 2:
                    error_1 = _d.sent();
                    if (!hasHttpResponse(error_1)) return [3 /*break*/, 7];
                    _d.label = 3;
                case 3:
                    _d.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, error_1.response.json()];
                case 4:
                    errorsResponse = _d.sent();
                    _a = handleError(errorsResponse, formatMessage), fieldErrors = _a.fieldErrors, modalErrors = _a.modalErrors;
                    applyFieldErrors(fieldErrors, setError);
                    if (modalErrors.length > 0) {
                        setErrorMessages(modalErrors);
                        setErrorModalOpen(true);
                    }
                    if (Object.keys(fieldErrors).length === 0 &&
                        modalErrors.length === 0) {
                        showSaveError(error_1);
                    }
                    return [3 /*break*/, 6];
                case 5:
                    _b = _d.sent();
                    showSaveError(error_1);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 8];
                case 7:
                    showSaveError(error_1);
                    _d.label = 8;
                case 8: return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    if (isRegionsLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: title }, formatMessage({ id: "ui-br-legaldeposits.loading" }))));
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-legaldeposits.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: onCancel, buttonMessageId: "ui-br-legaldeposits.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: formatModalErrors(errorMessages), onClose: function () { return setErrorModalOpen(false); } }),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.libraries.accordion.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "name", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.libraries.field.name", required: true, error: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "type", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-legaldeposits.libraries.field.type", dataOptions: Object.values(LibraryDtoTypeEnum).map(function (type) { return ({
                                                value: type,
                                                label: formatMessage({
                                                    id: "ui-br-legaldeposits.libraryType.".concat(type),
                                                }),
                                            }); }) })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "regionId", render: function (_a) {
                                        var _b, _c;
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: function (e) {
                                                return field.onChange(e.target.value || null);
                                            }, labelId: "ui-br-legaldeposits.libraries.field.region", dataOptions: __spreadArray([
                                                {
                                                    value: "",
                                                    label: formatMessage({
                                                        id: "ui-br-legaldeposits.libraries.field.select.label.default",
                                                    }),
                                                }
                                            ], ((_c = regionsData === null || regionsData === void 0 ? void 0 : regionsData.items) !== null && _c !== void 0 ? _c : []).map(function (region) {
                                                var _a, _b;
                                                return ({
                                                    value: (_a = region.id) !== null && _a !== void 0 ? _a : "",
                                                    label: (_b = region.name) !== null && _b !== void 0 ? _b : "",
                                                });
                                            }), true) })));
                                    } })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.libraries.accordion.legalDeposits",
                        }), open: accordionStatus.legalDeposits, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { legalDeposits: !accordionStatus.legalDeposits }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(InfoBox, { titleId: "ui-br-legaldeposits.libraries.info.title" },
                                    React.createElement("ul", { className: styles.infoList },
                                        React.createElement("li", null,
                                            React.createElement("strong", null,
                                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.nonPeriodicalsAllRegions" })),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.nonPeriodicalsAllRegions.text" })),
                                        React.createElement("li", null,
                                            React.createElement("strong", null,
                                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.nonPeriodicalsOwnRegion" })),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.nonPeriodicalsOwnRegion.text" })),
                                        React.createElement("li", null,
                                            React.createElement("strong", null,
                                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.periodicals" })),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.periodicals.text" })),
                                        React.createElement("li", null,
                                            React.createElement("strong", null,
                                                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.valueZero" })),
                                            React.createElement("br", null),
                                            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.libraries.info.valueZero.text" }))))),
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "nonPeriodicalsCountAllRegions", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { type: "number", min: 0, max: 2, step: 1, value: field.value, onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, labelId: "ui-br-legaldeposits.libraries.field.nonPeriodicalsAllRegions", error: (_b = errors.nonPeriodicalsCountAllRegions) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "nonPeriodicalsCountOwnRegion", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { type: "number", min: 0, max: 1, step: 1, value: field.value, onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, labelId: "ui-br-legaldeposits.libraries.field.nonPeriodicalsOwnRegion", error: (_b = errors.nonPeriodicalsCountOwnRegion) === null || _b === void 0 ? void 0 : _b.message, disabled: !regionId })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6, xl: 4 },
                                React.createElement(Controller, { control: control, name: "periodicalsCount", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { type: "number", min: 0, max: 2, step: 1, value: field.value, onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, labelId: "ui-br-legaldeposits.libraries.field.periodicals", error: (_b = errors.periodicalsCount) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "canRequestCopies", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) {
                                                return field.onChange(e.target.checked);
                                            }, label: formatMessage({
                                                id: "ui-br-legaldeposits.libraries.field.canRequestCopies",
                                            }) }));
                                    } })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.libraries.accordion.communication",
                        }), open: accordionStatus.communication, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { communication: !accordionStatus.communication }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "correspondenceContact", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(TextArea, __assign({}, field, { label: formatMessage({
                                                id: "ui-br-legaldeposits.libraries.field.correspondenceContact",
                                            }), error: (_b = errors.correspondenceContact) === null || _b === void 0 ? void 0 : _b.message })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("div", { className: styles.checkboxWithHelp },
                                    React.createElement(Controller, { control: control, name: "includeReferentInSignature", render: function (_a) {
                                            var field = _a.field;
                                            return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) {
                                                    return field.onChange(e.target.checked);
                                                }, label: formatMessage({
                                                    id: "ui-br-legaldeposits.libraries.field.includeReferentInSignature",
                                                }) }));
                                        } }),
                                    React.createElement(HelpTooltip, { id: "include-referent-signature-help", textId: "ui-br-legaldeposits.libraries.field.includeReferentInSignature.help", hasLabel: false })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "remindersEnabled", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Checkbox, { checked: field.value, onChange: function (e) {
                                                return field.onChange(e.target.checked);
                                            }, label: formatMessage({
                                                id: "ui-br-legaldeposits.libraries.field.remindersEnabled",
                                            }) }));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "defaultReminderOffsetDays", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { type: "number", min: 0, max: 365, step: 1, value: field.value, onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, labelId: "ui-br-legaldeposits.libraries.field.defaultReminderOffsetDays", error: (_b = errors.defaultReminderOffsetDays) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })),
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "defaultMinGapDays", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { type: "number", min: 1, max: 365, step: 1, value: field.value, onChange: function (e) {
                                                return field.onChange(Number(e.target.value));
                                            }, labelId: "ui-br-legaldeposits.libraries.field.defaultMinGapDays", error: (_b = errors.defaultMinGapDays) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })))),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.libraries.accordion.dataCollection",
                        }), open: accordionStatus.dataCollection, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { dataCollection: !accordionStatus.dataCollection }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "librarySystem", render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-legaldeposits.libraries.field.librarySystem", dataOptions: Object.values(LibraryDtoLibrarySystemEnum).map(function (system) { return ({
                                                value: system,
                                                label: formatMessage({
                                                    id: "ui-br-legaldeposits.librarySystem.".concat(system),
                                                }),
                                            }); }) })));
                                    } }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Controller, { control: control, name: "oaiUrlMonography", render: function (_a) {
                                        var _b;
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.libraries.field.oaiUrlMonography", error: (_b = errors.oaiUrlMonography) === null || _b === void 0 ? void 0 : _b.message })));
                                    } })))))))));
};
export { LibraryForm };
